import React, { useState } from "react";
import CreateDocLoading from "../../assets/images/create-doc-loading.png";
import NeumetricLogoImg from "../../assets/images/neumetric-logo.png";
import ProfilePicImg from "../../assets/images/profile_pic.png";
import Eval404Img from "../../assets/images/404-eval.png";
import LoadingOvalImg from "../../assets/images/Loading_Oval.png";
import LoadingGIFImg from "../../assets/images/Loading.gif";
import LoadingWhiteGIFImg from "../../assets/images/Loading-white.gif";
import LogInOval from "../../assets/images/login-oval.png";
//Logo
// import FusionLogoImg from "../../assets/images/fusion-logo.png";
import FusionLogoImg from "../../assets/images/Fusion_Logo2.png";
//Icon
import WarningIconImg from "../../assets/images/warning.png";
import FusionIconImg from "../../assets/images/fusion-icon.png";

export const getModuleIconLink = (moduleName) => {
  return `https://nmlogoicon.s3.ap-south-1.amazonaws.com/Icon${moduleName}.png`;
};
export const getModuleLogoLink = (moduleName) => {
  return `https://nmlogoicon.s3.ap-south-1.amazonaws.com/Logo${moduleName}.png`;
};
export const CreateDocLoadingImg = (props) => {
  return <img src={CreateDocLoading} {...props} />;
};
export const LogInOvalImg = (props) => {
  return <img src={LogInOval} {...props} />;
};
export const ProfilePic = (props) => {
  return <img src={ProfilePicImg} {...props} />;
};
export const Eval404 = (props) => {
  return <img src={Eval404Img} {...props} />;
};
export const LoadingOval = (props) => {
  return <img src={LoadingOvalImg} {...props} />;
};
export const LoadingGIF = (props) => {
  return <img src={LoadingGIFImg} {...props} />;
};
export const LoadingWhiteGIF = (props) => {
  return <img src={LoadingWhiteGIFImg} {...props} />;
};
//Logos
export const CentralLogo = (props) => {
  return <img src={getModuleLogoLink("Central")} {...props} />;
};
export const AuditorLogo = (props) => {
  return <img src={getModuleLogoLink("Auditor")} {...props} />;
};
export const DocumenterLogo = (props) => {
  return <img src={getModuleLogoLink("Documenter")} {...props} />;
};
export const ControllerLogo = (props) => {
  return <img src={getModuleLogoLink("Controller")} {...props} />;
};
export const EducatorLogo = (props) => {
  return <img src={getModuleLogoLink("Educator")} {...props} />;
};
export const InvestigatorLogo = (props) => {
  return <img src={getModuleLogoLink("Investigator")} {...props} />;
};
export const RemediatorLogo = (props) => {
  return <img src={getModuleLogoLink("Remediator")} {...props} />;
};
export const ContinuerLogo = (props) => {
  return <img src={getModuleLogoLink("Continuer")} {...props} />;
};
//Icons
export const AuditorIcon = (props) => {
  return <img src={getModuleIconLink("Auditor")} {...props} />;
};
export const RemediatorIcon = (props) => {
  return <img src={getModuleIconLink("Remediator")} {...props} />;
};
export const ConsoleIcon = (props) => {
  return <img src={getModuleIconLink("Console")} {...props} />;
};
export const DocumentorIcon = (props) => {
  return <img src={getModuleIconLink("Documenter")} {...props} />;
};
export const ControllerIcon = (props) => {
  return <img src={getModuleIconLink("Controller")} {...props} />;
};
export const EducatorIcon = (props) => {
  return <img src={getModuleIconLink("Educator")} {...props} />;
};
export const InvestigatorIcon = (props) => {
  return <img src={getModuleIconLink("Investigator")} {...props} />;
};
export const ContinuerIcon = (props) => {
  return <img src={getModuleIconLink("Continuer")} {...props} />;
};
export const CentralIcon = (props) => {
  return <img src={getModuleIconLink("Central")} {...props} />;
};
export const FusionIcon = (props) => {
  return <img src={FusionIconImg} {...props} />;
};

export const FusionLogo = (props) => {
  return <img src={FusionLogoImg} {...props} />;
};
export const NeumetricLogo = (props) => {
  return <img src={NeumetricLogoImg} {...props} />;
};
export const CompanyLogo = (props) => {
  const { user } = props;
  let [error, setError] = useState(false);
  return (
    <React.Fragment>
      {error ? (
        <NeumetricLogo alt="company Logo" className="company" />
      ) : (
        <img
          src={
            "https:" +
            (user.logo_url
              ? user.logo_url
              : user.ent_org && user.ent_org.logo_url
              ? user.ent_org.logo_url
              : "")
          }
          alt="company Logo"
          className="company"
          onError={() => setError(true)}
        />
      )}
    </React.Fragment>
  );
};
export const WarningIcon = (props) => {
  return <img src={WarningIconImg} {...props} />;
};
